import { ENDPOINTS } from '@/constants/api'
import { QUERY_KEYS } from '@/constants/query-keys'
import type { RequestBodyOf, ResponseData } from '@/types/api'
import { apiSlice } from './base'

export type Setting = ResponseData<'/api/v1/settings/', 'get'>[number]
type UpdateSettingBody = RequestBodyOf<'/api/v1/settings/{key}', 'put'>

export const settingsApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getSettings: builder.query<Setting[], void>({
      query: () => ENDPOINTS.SETTINGS.ROOT,
      transformResponse: (response: { data: Setting[] }) => response.data,
      providesTags: [{ type: QUERY_KEYS.SETTINGS, id: 'LIST' }],
    }),
    updateSetting: builder.mutation<Setting, { key: string; body: UpdateSettingBody }>({
      query: ({ key, body }) => ({ url: ENDPOINTS.SETTINGS.BY_KEY(key), method: 'PUT', body }),
      transformResponse: (response: { data: Setting }) => response.data,
      invalidatesTags: [{ type: QUERY_KEYS.SETTINGS, id: 'LIST' }],
    }),
    deleteSetting: builder.mutation<void, string>({
      query: (key) => ({ url: ENDPOINTS.SETTINGS.BY_KEY(key), method: 'DELETE' }),
      invalidatesTags: [{ type: QUERY_KEYS.SETTINGS, id: 'LIST' }],
    }),
  }),
  overrideExisting: false,
})

export const { useGetSettingsQuery, useUpdateSettingMutation, useDeleteSettingMutation } =
  settingsApi
